import {Component, computed, input, ChangeDetectionStrategy} from '@angular/core';
import {NavigationItem} from "../overview-navigation-tabs.component";

@Component({
  selector: 'app-overview-navigation-tab-item',
  templateUrl: './overview-navigation-tab-item.component.html',
  styleUrl: './overview-navigation-tab-item.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OverviewNavigationTabItemComponent {
  item = input<NavigationItem>();
  urlPath = computed<string>(() => window.location.pathname);
}
